import { render, staticRenderFns } from "./WxDebind.vue?vue&type=template&id=58945faf&"
import script from "./WxDebind.vue?vue&type=script&lang=js&"
export * from "./WxDebind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports